<template>
  <div class="h-100">
    <main role="main" class="h-100">
        <common-master-table
          primary-key="taskSerialId"
          table-no="trTask"
          table-api="work/task"
          ref="commonMasterTable"
          :editable="editableMixin.task"
          :mapping-no="`ie-task`"
          :hideDeleteToAction="isHideDeleteIcon"
          :hideChbxColumn="true"
          :hideChbxAllColumn="hideChbxAllColumn"
          :removeKeyOptional="removeKeyOptional"
          :hideFirstColHeader="false"
          :hideButtonImportCsv="true"
          :hideButtonAdd="true"
          :hideButtonDeleteAll="true"
          :handleShowCheckBox="true"
          :showLockMasterButton="false"
          socket-entity="TASK_SOCKET"
          @show-modal-edit="handleShowModalEdit"
          @on-show-check-box="isCheckboxDisplayed"
        />
    </main>
  </div>
</template>

<script>
import CommonMasterTable from '../custom-components/CommonMasterTable'
import CommonUtils from '../../mixins/commonUtils'
import RouterUtils from '../../_helpers/router.util'
import { BatchStatus } from '../../enums/batch-status.enums.js'
const ALLOWED_DELETE_REJECT_TASK_STATUS_LIST = [BatchStatus.PROCESSING, BatchStatus.COMPLETED]
export default {
  components: {
    // コンポーネント分割化
    CommonMasterTable, BatchStatus
  },
  mixins: [CommonUtils],
  data() {
    return {
      tableNo: 'trTask',
      removeKeys: [],
      updateQueryStr: '',
      isHideDeleteIcon: true,
      hideChbxAllColumn: true,
      removeKeyOptional: []

    }
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.hasOwnProperty('limit') && Object.keys(to.query).length === 1) {
      RouterUtils.correctTableRowsLimitParam(to.query)
      this.$refs.commonMasterTable.initData()
    }
  },
  methods: {
    /**
     * モーダル編集を表示
     * @param {object} data - タスクマスターデータ
     */
    handleShowModalEdit(data) {
      if (!data || !data.editItem) {
        return
      }
      const {editItem, noWorkTaskType, rejectChuteNo} = data
      this.isHideDeleteIcon = !this.allowDeleteTask(editItem, noWorkTaskType, rejectChuteNo)
    },
    /** 各項目のチェックボックスの表示条件 */
    isCheckboxDisplayed() {
      this.removeKeyOptional = []
      // 共通マスター表のデータ
      let data = this.$refs.commonMasterTable
      if (data) {
        let taskDatas = data.tableData
        let noWorkTaskType = data.noWorkTaskType
        let rejectChuteNo = data.rejectChuteNo
        // データを確認して削除を許可する
        taskDatas.forEach(task => {
          if (this.allowDeleteTask(task, noWorkTaskType, rejectChuteNo)) {
            task.hideChbxColumn = false
            this.removeKeyOptional.push(task[this.taskSerialId])
          }
        })

        // 表示/非表示をチェック すべての列を削除
        if (this.removeKeyOptional.length <= 0) {
          this.hideChbxAllColumn = true
        } else {
          this.hideChbxAllColumn = false
        }
      }
    },
    /**
     * 削除タスクを許可する。
     * @param {object} task - タスク
     * @param {Array} noWorkTaskType -（作業指示なし）タスクタイプリスト
     * @param {String} rejectChuteNo - リジェクトの予約シュートNo
     * @return {Boolean} - タスクが削除を許可する場合は true 。それ以外の場合は false
     */
    allowDeleteTask(task, noWorkTaskType, rejectChuteNo) {
      if (!task) {
        return false
      }

      // タスクがオーダーではなくステータスが処理中の場合、タスクの削除を許可する
      const isNoWorkTaskTypeProcessing = task.status === BatchStatus.PROCESSING && noWorkTaskType.includes(task.taskType)

      // タスクが拒否され、ステータスが処理中または完了の場合は、タスクの削除を許可します
      const rejectTaskCanDelete = ALLOWED_DELETE_REJECT_TASK_STATUS_LIST.includes(task.status) && task.chuteNo === rejectChuteNo
      return isNoWorkTaskTypeProcessing || rejectTaskCanDelete
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mst-tables/TaskStatement.vue